export default __webpack_public_path__ + "static/poster-ef39fc7f52c60cbc491825a5156a76e6.png";